var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6235 3.87695H4.37695V14.1235H14.6235V3.87695Z",
    stroke: "#474F60",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54102 14.0075L8.38007 10.1685L12.226 14.0075",
    stroke: "#474F60",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1465 8.82275C11.901 8.82275 12.5127 8.21108 12.5127 7.45654C12.5127 6.70201 11.901 6.09033 11.1465 6.09033C10.3919 6.09033 9.78027 6.70201 9.78027 7.45654C9.78027 8.21108 10.3919 8.82275 11.1465 8.82275Z",
    stroke: "#474F60",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageBlack);
export default __webpack_public_path__ + "static/media/icon_image_black.06135251566702c46a8bebc8f1cbb659.svg";
export { ForwardRef as ReactComponent };